<app-header *ngIf="!isEmbedWLSMode"></app-header>
<!-- Minimal header with logo for embed/preview mode -->
<div *ngIf="isEmbedWLSMode" class="wls-preview-header">
  <img
    *ngIf="previewLogoUrl"
    [src]="previewLogoUrl"
    alt="Logo"
    class="wls-preview-logo"
  />
</div>
<div
  [ngClass]="{
    'main-wrapper container with-sidebar': showSidebar,
    'wls-quick-preview': isEmbedWLSMode
  }"
>
  <app-sidebar *ngIf="showSidebar"></app-sidebar>
  <div class="router-outlet-wrapper" [ngClass]="{'with-sidebar': showSidebar}">
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
</div>
<app-footer *ngIf="!isEmbedWLSMode"></app-footer>
<app-minimized-player></app-minimized-player>
<app-dev-toolbar *ngIf="showDevToolbar"></app-dev-toolbar>